import { render, staticRenderFns } from "./tracklist-block.vue?vue&type=template&id=ea6bcd38"
import script from "./tracklist-block.vue?vue&type=script&setup=true&lang=js"
export * from "./tracklist-block.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports